module.exports = __webpack_public_path__ + "1792395595471/images/owl.video.play.4a37f80.png";